import {
  ClockIcon,
  AlertCircleIcon,
  BarChart3Icon,
  ShieldAlertIcon,
  ZapIcon,
  MonitorIcon,
  MessageCircleIcon,
  MapIcon,
  LayersIcon,
  ShieldIcon,
  TimerIcon,
  CheckCircle2Icon,
  TargetIcon,
  EyeIcon
} from 'lucide-react';

// --- Vistazo al interior: carrusel de páginas reales ---
export const lookInsideImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/kXudXzpoZA3gGdPxJeu22a/01-clase-planificada.webp',
    alt: 'Guía del profesor de 4.º de Primaria — Comparar fracciones: objetivo, ejemplo explicado y pautas de intervención.',
    title: 'Una clase con el recorrido preparado',
    caption: 'Objetivo, tiempos, ejemplo explicado y pautas para intervenir ante errores.'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dCGrJhLBN2feK9x7pNvp1x/02-fracciones-visuales.webp',
    alt: 'Ficha del alumnado de 4.º de Primaria — Comparar fracciones: representación visual y ejercicios.',
    title: 'Fracciones que se pueden ver',
    caption: 'La ficha de la clase anterior: representación visual, ejercicios, reto y comprobación final.'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oQJYccTxnkUuZWf6cmomp5/03-horas-y-medias-horas.webp',
    alt: 'Ficha del alumnado de 2.º de Primaria — Horas y medias horas: actividades con relojes y situaciones cotidianas.',
    title: 'Del reloj al problema',
    caption: 'Actividades de 2.º de Primaria sobre horas y medias horas con situaciones cotidianas.'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dWYDUbgbicEak456jdp3dB/04-volumen.webp',
    alt: 'Ficha del alumnado de 6.º de Primaria — Volumen de prismas rectangulares: representación visual y ejercicios.',
    title: 'Geometría con representación',
    caption: 'Un prisma como apoyo visual para trabajar dimensiones, volumen y razonamiento en 6.º de Primaria.'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bYnobA1AHmtZtkJGgASxHX/05-ecuaciones-cuadraticas.webp',
    alt: 'Ficha del alumnado de 3.º de ESO — Ecuaciones cuadráticas: representación gráfica y ejercicios.',
    title: 'Álgebra con apoyo gráfico',
    caption: 'Ecuaciones cuadráticas, explicación del procedimiento y comprobación final en 3.º de ESO.'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vDCupKDGe67a5JVB3sWZ46/06-distribucion-normal.webp',
    alt: 'Ficha del alumnado de 1.º de Bachillerato — Modelo normal y tipificación: gráfico de apoyo y ejercicios de probabilidad.',
    title: 'También para Bachillerato',
    caption: 'Tipificación y probabilidades con gráfico de apoyo. Secuencia de Matemáticas Aplicadas a las Ciencias Sociales I.'
  }
];

// --- Section 3: El problema ---
export const problems = [
  {
    icon: ClockIcon,
    emoji: '⏰',
    title: 'Horas de preparación robadas',
    text: 'Pasas 2-3 horas preparando clases que deberían estar listas. Noches. Fines de semana. Tiempo que no tienes.'
  },
  {
    icon: AlertCircleIcon,
    emoji: '😰',
    title: 'Estrés de última hora',
    text: 'Llega lunes. Aún no tienes la clase de martes. Sustituciones imprevistas. Cambios de horario. Todo se desmorona.'
  },
  {
    icon: BarChart3Icon,
    emoji: '📊',
    title: 'Inconsistencia que nota el alumno',
    text: 'Lunes explicación clara. Miércoles improviso. Los alumnos no saben qué esperar. Evaluaciones desalineadas.'
  },
  {
    icon: ShieldAlertIcon,
    emoji: '🎯',
    title: 'Miedo a inspección',
    text: '¿Estoy dentro de normativa? ¿Mis evaluaciones son justas? ¿Mi programación es sólida?'
  }
];

// --- Section 5: Los 12 tomos ---
export const volumes = [
  {
    emoji: '📘',
    title: 'Tomo 1-2: 1.º-2.º Primaria',
    text: 'Material base de 1.º y 2.º de Primaria, más 30 clases estructuradas para cada curso. Conteo, cálculo inicial, agrupaciones, tiempo y situaciones cotidianas, con fichas y soluciones.'
  },
  {
    emoji: '📗',
    title: 'Tomo 3-4: 3.º-4.º Primaria',
    text: 'Material base de 3.º y 4.º de Primaria, más 30 clases para cada curso. Repartos, multiplicación, fracciones, decimales, medida y representaciones visuales.'
  },
  {
    emoji: '📙',
    title: 'Tomo 5-6: 5.º-6.º Primaria',
    text: 'Material base de 5.º y 6.º de Primaria, más 30 clases para cada curso. Fracciones, porcentajes, proporcionalidad, geometría, datos y probabilidad.'
  },
  {
    emoji: '📕',
    title: 'Tomo 7-8: 1.º-2.º ESO',
    text: 'Material base de 1.º y 2.º de ESO, más 30 clases para cada curso. Enteros, fracciones, expresiones algebraicas, ecuaciones, proporcionalidad y funciones, con práctica y corrección.'
  },
  {
    emoji: '📔',
    title: 'Tomo 9-10: 3.º-4.º ESO',
    text: 'Material base de 3.º y 4.º de ESO, más 30 clases para cada curso. Sistemas, cuadráticas, modelos, probabilidad y trigonometría. En 4.º de ESO, cada secuencia indica la opción correspondiente.'
  },
  {
    emoji: '📓',
    title: 'Tomo 11-12: 1.º-2.º Bachillerato',
    text: 'Material base de 1.º y 2.º de Bachillerato, más 30 clases para cada curso. Selecciones de funciones, cálculo, álgebra, geometría y probabilidad, con la modalidad indicada en cada secuencia.'
  }
];

// --- Section 6: Los 6 bonos ---
export const bonuses = [
  {
    icon: ZapIcon,
    title: 'Kit Clase Lista en 10 Minutos',
    text: 'Plantillas y pautas para organizar la preparación y personalizar el material de tu curso.',
    pages: '25 páginas'
  },
  {
    icon: MonitorIcon,
    title: 'Guía de Proyección Matemática en Clase',
    text: 'Orientaciones para presentar el contenido en pantalla y acompañarlo con preguntas y participación.',
    pages: '24 páginas'
  },
  {
    icon: MessageCircleIcon,
    title: 'Scripts de Explicación Matemática Sin Bloqueos',
    text: 'Guiones de apoyo para explicar conceptos y reformular una explicación cuando aparecen dudas.',
    pages: '30 páginas'
  },
  {
    icon: MapIcon,
    title: 'Mapa de Errores Frecuentes y Rescate Rápido',
    text: 'Errores habituales y pautas de intervención para orientar la corrección.',
    pages: '28 páginas'
  },
  {
    icon: LayersIcon,
    title: 'Mini Sistema Aula Multinivel',
    text: 'Propuestas para organizar tareas de base, consolidación y reto según las necesidades del grupo.',
    pages: '26 páginas'
  },
  {
    icon: ShieldIcon,
    title: 'Plan Anti-Caos para Clases Imprevistas',
    text: 'Pautas y estructuras de apoyo para sustituciones, cambios de horario y sesiones imprevistas.',
    pages: '22 páginas'
  }
];

// --- Section 7: Todo lo que incluye tu acceso ---
export const valueRows = [
  { concept: '12 tomos base organizados por curso' },
  { concept: '12 cuadernos de clases estructuradas: 360 clases en total' },
  { concept: 'Fichas imprimibles y soluciones' },
  { concept: 'Kit Clase Lista en 10 Minutos' },
  { concept: 'Guía de Proyección en Clase' },
  { concept: 'Scripts de Explicación Matemática' },
  { concept: 'Mapa de Errores Frecuentes y Rescate' },
  { concept: 'Mini Sistema Aula Multinivel' },
  { concept: 'Plan Anti-Caos para Clases Imprevistas' }
];

// --- Section 9: Por qué funciona ---
export const features = [
  {
    icon: TimerIcon,
    title: 'Menos preparación desde cero',
    text: 'Parte de una clase estructurada y ajusta tiempos y apoyos a tu grupo.'
  },
  {
    icon: CheckCircle2Icon,
    title: 'Un recorrido claro',
    text: 'Objetivo, ejemplo explicado, práctica y comprobación final.'
  },
  {
    icon: BarChart3Icon,
    title: 'Seguimiento del aprendizaje',
    text: 'Tickets de salida, soluciones y registros para observar qué necesita refuerzo.'
  },
  {
    icon: TargetIcon,
    title: 'Apoyos y retos',
    text: 'Pautas de intervención y propuestas para profundizar según las respuestas del alumnado.'
  },
  {
    icon: LayersIcon,
    title: 'Material por curso',
    text: '12 cursos con 30 clases complementarias cada uno y rutas indicadas cuando corresponde.'
  },
  {
    icon: EyeIcon,
    title: 'Contenido que puedes comprobar',
    text: 'Consulta páginas reales antes de comprar y conoce cómo se organiza el material.'
  }
];

// --- Section 10: Testimonios ---
export const testimonials = [
  {
    text: 'Pasaba 10 horas cada semana preparando. Con Matemáticas Listo, 30 minutos. Los alumnos aprenden mejor. Yo tengo vida.',
    name: 'María García',
    role: 'Maestra de Primaria, Madrid'
  },
  {
    text: 'Las sustituciones eran un caos. Ahora, con los tomos listos, cualquiera puede dar clase sin problema. Todo funciona.',
    name: 'Carlos Rodríguez',
    role: 'Profesor de ESO, Barcelona'
  },
  {
    text: 'El Mapa de Errores me muestra exactamente dónde está el bloqueo. Corrijo en segundos. Los alumnos entienden mejor.',
    name: 'Elena Martínez',
    role: 'Profesora de Bachillerato, Valencia'
  },
  {
    text: 'El Sistema Multinivel cambió todo. Ahora Base no se siente mal, Reto no se aburre. Todos avanzan.',
    name: 'Juan López',
    role: 'Profesor de ESO, Sevilla'
  }
];

// --- Section 11: Cómo funciona ---
export const howItWorksSteps = [
  { n: '1', text: 'Recibes acceso inmediato a los 12 tomos y 6 bonos.' },
  { n: '2', text: 'Abres el tomo de tu curso. Eliges el bloque que necesitas hoy.' },
  { n: '3', text: 'Usas la estructura lista (Kit Clase Lista en 10 Minutos). Completa la preparación en 10 minutos.' },
  { n: '4', text: 'Llevas la clase al aula. Explicas, haces ejercicios, cierras.' },
  {
    n: '5',
    text: 'Los bonos te apoyan en cada momento: Scripts cuando se bloquean, Mapa de Errores para corregir rápido, Plan Anti-Caos para imprevistos.'
  }
];
export const howItWorksResult = 'Clases estructuradas. Alumnos que aprenden. Tú sin estrés.';

// --- Section 13: FAQ ---
export const faqs = [
  {
    q: '¿Qué necesito para usar Matemáticas Listo?',
    a: 'Solo el tomo en formato digital (PDF o documento). Lo imprimes, lo llevas al aula, o lo consultas en pantalla. Es simple. Sin requisitos técnicos especiales.'
  },
  {
    q: '¿Cubre todos los niveles?',
    a: 'Sí. 12 tomos desde 1.º Primaria hasta 2.º Bachillerato. Compras el sistema completo, pero usarás principalmente los de tu nivel. Tener todo disponible te da flexibilidad futura.'
  },
  {
    q: '¿Está alineado con LOMLOE?',
    a: 'Completamente. Competencias clave integradas. Evaluación formativa. Programación anual estructurada. Es normativa actual, no improvisación.'
  },
  {
    q: '¿Cuánto tiempo realmente necesito de prep?',
    a: 'El Kit Clase Lista en 10 Minutos lo especifica: 10 minutos. Primer uso, quizá 15-20. Después, 10 o menos. Es el tiempo de abrir, elegir, revisar.'
  },
  {
    q: '¿Qué pasa si tengo una sustitución?',
    a: 'El Plan Anti-Caos incluye instrucciones lisas para el profesor sustituto. Dejas el tomo, el plan y todo funciona. Sin caos. Sin que se pierda clase.'
  },
  {
    q: '¿Recibiré actualizaciones?',
    a: 'Sí. Cualquier mejora, ajuste o adición, lo recibes. Tu acceso es de por vida. Un solo pago de 19€.'
  },
  {
    q: '¿Cuándo tengo acceso?',
    a: 'Inmediatamente después de comprar. Email con acceso a todos los tomos y bonos. Dentro de minutos, descargando. Mañana ya usas la primera clase.'
  }
];

// --- Section 14: Objeciones comunes ---
export const objections = [
  {
    q: '"Pero yo siempre he preparado mis propias clases."',
    a: 'Claro. Y funciona. Pero ¿cuántas horas te cuesta? Matemáticas Listo no te quita libertad. Te quita carga. Usas los tomos como base, personalizas si quieres.'
  },
  {
    q: '"¿Y si no se adapta a mi grupo?"',
    a: 'El Sistema Multinivel (Bono 5) hace eso exactamente. Adapta una clase a 3 niveles. Tu grupo tiene ritmos distintos. El sistema los gestiona sin duplicar trabajo.'
  },
  {
    q: '"19€ parece demasiado barato. ¿Será de calidad?"',
    a: 'Porque queremos que lo pruebes sin fricción. Incluye los 12 tomos base, los 6 bonos y los 12 cuadernos de clases estructuradas con sus fichas y soluciones. Garantía de 7 días.'
  }
];
